import * as RadixPopover from '@radix-ui/react-popover';
import type { ReactElement, ReactNode } from 'react';
import { useMediaQuery } from '../../lib/media.ts';
import styles from './Popover.module.css';
import { Sheet } from './Sheet.tsx';

export interface PopoverProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  /** The element that toggles the popover. */
  readonly trigger: ReactElement;
  /** Heading of the phone sheet and accessible name of the panel. */
  readonly title: string;
  readonly align?: 'start' | 'center' | 'end' | undefined;
  readonly side?: 'top' | 'bottom' | 'left' | 'right' | undefined;
  readonly children: ReactNode;
}

/** Non-modal panel anchored to its trigger; a bottom sheet on phones. */
export const Popover = ({
  open,
  onOpenChange,
  trigger,
  title,
  align = 'end',
  side = 'top',
  children,
}: PopoverProps) => {
  const phone = useMediaQuery('phone');
  if (phone) {
    return (
      <Sheet open={open} onOpenChange={onOpenChange} title={title} trigger={trigger}>
        {children}
      </Sheet>
    );
  }
  return (
    <RadixPopover.Root open={open} onOpenChange={onOpenChange}>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          className={styles.content}
          align={align}
          side={side}
          sideOffset={8}
          collisionPadding={12}
          aria-label={title}
        >
          {children}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
};
